import React, { useState } from 'react';
import { Layout } from 'antd';
import Sidebar from './Sidebar';
import MainHeader from './MainHeader';
import PayrollInspectionWizard from './PayrollInspectionWizard';

const { Content } = Layout;

export default function PayrollInspection() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} />
      <Layout style={{ marginLeft: collapsed ? 80 : 200, height: '100vh', overflow: 'hidden' }}>
        <MainHeader collapsed={collapsed} setCollapsed={setCollapsed} title="Payroll Audit & Inspection" />
        <Content style={{ margin: '24px 16px', padding: 24, background: '#f5f5f5', height: 'calc(100vh - 64px - 48px)', overflow: 'auto' }}>
          <PayrollInspectionWizard />
        </Content>
      </Layout>
    </Layout>
  );
}
